import Img from 'src/components/shared/Img'

const TestimonialCard = ({ isMobileVariantBActive, heroPersonV2 = {} }) => {
  const varinatBClassName = isMobileVariantBActive ? 'hidden sm:block' : ''

  return (
    <div
      className={`flex flex-col items-center text-center ${
        isMobileVariantBActive ? 'p-0 sm:p-6' : 'p-6'
      }`}
    >
      {/* Profile Image & Speech Bubble */}
      <div className={`size-80 lg:size-100 relative mb-6 ${varinatBClassName}`}>
        <div
          className="shadow-lg size-full overflow-hidden rounded-full border-4 border-white"
          data-testid="testimonial-image-container"
        >
          <Img
            src={
              heroPersonV2?.image
                ? heroPersonV2?.image
                : '/next-assets/testimonials/testimonials-card-img.webp'
            }
            alt="Client Testimonial"
            layout="fill"
            className="size-full"
            imgClassName="object-cover"
            priority
          />
        </div>
        {/* Speech Bubble */}
        <div className="absolute top-5 right-3 flex items-center rounded-lg lg:top-0 lg:right-0">
          <Img
            src="/next-assets/heart-icon.png"
            alt="Client Testimonial"
            className="size-[50px] lg:size-[81px]"
            width={81}
            height={82}
            layout="intrinsic"
            loading="eager"
          />
        </div>
      </div>

      {/* Testimonial Text */}
      <div
        className={`z-50 mt-[-50px] max-w-sm rounded-lg bg-blue-700 px-3 py-primary-xxs text-sm text-white ${varinatBClassName}`}
        data-testid="hero-testimonial-text-container"
      >
        “
        {heroPersonV2?.conclusion
          ? heroPersonV2?.conclusion
          : 'Within a year, my first card was paid off. Then the second, then the third... After only a few years, all my debts were paid off.'}
        ”
        <span className="font-bold">
          {' '}
          – {heroPersonV2?.name ? heroPersonV2?.name : 'Patti B.¹'}
        </span>
      </div>
      <p
        className="mt-4 hidden max-w-xs whitespace-pre-line text-sm italic text-gray-500 sm:block"
        data-testid="testimonial-disclaimer"
      >
        {heroPersonV2?.description || (
          <>
            Actual client of Freedom Debt Relief.
            <br />
            Individual results are not typical and will vary.
          </>
        )}
      </p>
    </div>
  )
}

export default TestimonialCard
